const ancestor = "推广";
const ActivityRouter = [
  /* 活动首页 */
  {
    path: "/activity",
    name: "activity",
    meta: { screen: false, title: "活动",keepAlive:true, ancestor },
    component: () => import("@/views/activity/Index.vue"),
  },
  /* 活动详情页 */
  {
    path: "/activity/detail/:id",
    name: "activity-detail",
    meta: { screen: false, title: "活动", ancestor },
    component: () => import("@/views/activity/detail/Index.vue"),
  },
];
export default ActivityRouter;
